<template>
  <Toast/>
  <div class="row justify-content-center">
    <h2 class="titre">Choix du profil</h2>
    <div class="col-8">
      <div class="alert alert-warning " role="alert">
        <div class="h4 alert-heading">Système Cardex</div>
        <hr>
        <p class="avertissement text-left">En accédant au Cardex, vous vous engagez à assurer l'intégrité et à respecter
          le caractère hautement confidentiel de la documentation, des informations et des données obtenues dans le
          cadre de sa consultation.</p>
        <br>
        <p class="avertissement text-left">En vertu du préjudice que constitue l'utilisation et/ou la divulgation non
          autorisées des documents, des informations et des données contenus au Cardex pour Loto-Québec, la Société
          pourrait prendre tout recours jugé approprié envers l'utilisateur fautif.</p>
      </div>
    </div>
  </div>
  <div class="row">
    <DataTable class="p-datatable-sm"
               columnResizeMode="fit"
               selectionMode="single"
               dataKey="cle"
               sortField="siteAfficher"
               paginatorPosition="both"
               paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
               currentPageReportTemplate="Afficher {first} à {last} sur {totalRecords} profils"
               v-model:filters="filters"
               :resizableColumns="true"
               :reorderableColumns="true"
               :paginator="true"
               :value="listeProfils"
               :sortOrder="1"
               :rowClass="rowClass"
               :loading="loading"
               :rows="50"
               :rowsPerPageOptions="[10,25,50,100]"
               @row-select="choisirProfil">

      <template #header>
        <div class="row align-items-center">
          <div class="col-3">
            <div class="h5">Profils disponibles</div>
          </div>
          <div class="col-4">
            <input class="form-control" v-model="filters['global'].value" list="datalistOptions"
                   placeholder="Rechercher profil">
            <datalist id="datalistOptions">
              <option v-for="p of listeProfils" :key="p.cle" :value="p.code"/>
            </datalist>
          </div>
        </div>
      </template>

      <Column v-for="col of columns"
              :sortable="true"
              :showFilterMenu="true"
              :showFilterOperator="true"
              :showFilterMatchModes="true"
              :field="col.field"
              :header="col.header"
              :key="col.field">
      </Column>

      <Column
          :sortable="true"
          :showFilterMenu="true"
          :showFilterOperator="true"
          :showFilterMatchModes="true"
          :field="'autoriteAfficher'"
          :header="'Autorité'"
          :key="'autoriteAfficher'"
          :headerStyle="'width: 8%'">
      </Column>
      <Column
          :sortable="true"
          :showFilterMenu="true"
          :showFilterOperator="true"
          :showFilterMatchModes="true"
          :field="'confidentialiteAfficher'"
          :header="'Confidentialité'"
          :key="'confidentialiteAfficher'"
          :headerStyle="'width: 12%'">
      </Column>

    </DataTable>
  </div>
</template>

<script>
import {FilterMatchMode} from "primevue/api";
import {mapGetters} from 'vuex'

export default {
  name: "ChoixProfil",
  beforeMount() {
    this.$root.$refs.breadcrumbComp.ajout("Menu");
    var jeton = localStorage.getItem('jeton');
    if (jeton) {
      // Clean up localStorage if needed
      localStorage.removeItem('jeton');
    }
    if (jeton == null)
      jeton = this.jeton;
    this.$store.dispatch('cardex/validerJetonAction', jeton)
        .then((res) => {
          if (!res.data) {
            this.$store.commit('TOKEN_VALIDE', false);
            window.location.href ="/"
          } else {
            this.$store.getters['cardex/listeProfils'];
            this.listeProfils = this.$store.getters['cardex/listeProfils'];
          }
        })
        .catch((err) => {
          console.log(err)
          this.toast('error', this.MSG_ERREUR_JETON)
          window.location.href ="/"
        })
  },

  created() {
    this.MSG_SUCCESS = "Profil chargé. Redirection en cours..."
    this.MSG_ERREUR = "Échec lors du choix de profil, veuillez réessayer plus tard"
    this.MSG_ERREUR_JETON = "Échec lors de la validation du jeton"
  },
  mounted() {
    this.resetStore();
    if(this.listeProfils.length === 0){
      this.$store.dispatch('cardex/obtenirProfilsAction', JSON.parse(sessionStorage.getItem('intervenant')))
    }
  },
  data() {
    return {
      listeProfils: [],
      loading: false,
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
      columns: [
        {field: "code", header: "Profil"},
        {field: "siteAfficher", header: "Site d'origine"},
        {field: "secteurAfficher", header: "Secteur"},
        {field: "groupeSecuriteAfficher", header: "Groupe de sécurité"}
        //{ field: "autoriteAfficher", header: "Autorité" },
        //{ field: "confidentialiteAfficher", header: "Confidentialité" },
      ],
    }
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      tokenValide: 'cardex/tokenValide',
    })
  },
  methods: {
    getListProfile() {
      this.listeProfils
    },
    toast(level, msg) {
      this.$toast.add({severity: level, detail: msg, summary: 'Choix Profil', life: 6000});
    },
    choisirProfil(event) {
      this.loading = true
      this.$store.dispatch('cardex/obtenirJetonAction', event.data)
          .then(() => {
            this.toast('success', this.MSG_SUCCESS)
            if(this.profil.cleGroupeSecurite == 1947) {
              this.$router.push({name: "AccueilPilotage"});
            } else {
              this.$router.push({name: "AccueilDashboard"});
            }
          })
          .catch((err) => {
            console.log(err)
            this.toast('error', this.MSG_ERREUR)
            this.loading = false
          })
    },
    rowClass() {
    },
    resetStore() {
      this.$store.commit('dossier/DOSSIER_STORE_STATE_RESET');
      this.$store.commit('suivi/SUIVI_STORE_STATE_RESET');
      this.$store.commit('consignation/CONSIGNATION_STORE_STATE_RESET');
      this.$store.commit('vehicule/VEHICULE_STORE_STATE_RESET');
      this.$store.commit('sujet/SUJET_STORE_STATE_RESET');
      this.$store.commit('narration/NARRATION_STORE_STATE_RESET');
      this.$store.commit('societe/SOCIETE_STORE_STATE_RESET');
      this.$store.commit('adresse/ADRESSE_STORE_STATE_RESET')
      this.$store.commit('galerie/GALERIE_STORE_STATE_RESET')
    },
  },
};
</script>
